export default __webpack_public_path__ + "static/media/thop-vertical-mobile.45f2ea11.png";